var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseSnackbar'),_c('BaseModal'),_c('BaseSplash'),_vm._l((_vm.pages),function(page,index){return _c('div',{key:index},[_c(page.component,{tag:"component",attrs:{"content":page}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }